import { isConfigFlagEnabled } from '../config';
import { isLocalhostEnvironment } from '../utils/utils';
export const AVATAR_SERVICE_HOST = isLocalhostEnvironment()
    ? 'http://localhost:3000'
    : 'https://welcome-delora-triplejack-29d2c302.koyeb.app';
// Update this value with a new random token or the git commit of the avatar service where either
// a breaking change was made, or a need to break the cache on old avatars that were not using this version:
export const AVATAR_SERVICE_VERSION = '4b9507b';
export const AVATAR_FULL_TEXTURE_SIZE = 1024;
/**
 * Avatar textures may be scaled down from their full size for performance/memory reasons.
 */
export const AVATAR_TEXTURE_SIZE = isConfigFlagEnabled('smallerAvatarTextures') ? 512 : 1024;
export const AVATAR_TEXTURE_SCALE_FACTOR = AVATAR_TEXTURE_SIZE / AVATAR_FULL_TEXTURE_SIZE;
/**
 * Factor to adjust the final rendering size of an avatar.
 */
export const AVATAR_RENDER_SCALE_FACTOR = 1.4;
export const AVATAR_SHADOW_OFFSET_X_RATIO = 0.02;
export const AVATAR_SHADOW_OFFSET_Y_RATIO = AVATAR_SHADOW_OFFSET_X_RATIO * 2;
export const AVATAR_SHADOW_ALPHA = 0.3;
